export default __webpack_public_path__ + "static/media/home_pic2.1acd0006.png";